import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CreditCardIcon } from 'lucide-react';
import { Countdown } from './Countdown';
const trust = [{
  icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 minutos'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: CreditCardIcon,
  label: 'Tarjeta de débito o crédito'
}];
export function FinalCta() {
  return <section className="w-full border-t border-ink-800 bg-ink-900 py-20" id="checkout" aria-labelledby="cierre" data-id="element-91" data-mp="1jcd76hp3ycfp">
      <div className="mx-auto w-full max-w-4xl px-4 text-center sm:px-6" data-id="element-92" data-mp="1eds48aih1enk">
        <h2 id="cierre" className="font-display text-3xl font-900 leading-tight text-white sm:text-[2.75rem]" data-id="element-93" data-mp="1t1wq1nctm6ak">
          El sol ya está ahí. Gratis. Todos los días.
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-lg leading-relaxed text-slate-300" data-id="element-94" data-mp="224ef09jv1d19">
          La única decisión que falta es si vas a aprovecharlo con información real o si vas a
          seguir regalándole ese dinero a tu compañía eléctrica otro mes más.
        </p>
        <p className="mx-auto mt-4 max-w-2xl font-display text-lg font-700 text-gold" data-id="element-95" data-mp="s45ts71gznwc">
          Más de 1.200 familias en España y Latinoamérica ya tomaron esa decisión. Hoy es tu turno.
        </p>

        <div className="mx-auto mt-10 max-w-xl" data-id="element-96" data-mp="123emyxoigyhn">
          <Countdown label="El precio cierra en" data-id="element-97" data-mp="1246dvv75y81l" />
        </div>

        <div className="mt-8 flex justify-center" data-id="element-98" data-mp="163fbjb5bqq2f">
          <a href="#precios" className="rounded-xl bg-gold px-8 py-4 font-display text-base font-800 uppercase tracking-wide text-ink-950 transition-[transform,background-color] duration-150 ease-smooth hover:bg-gold-400 active:scale-[0.985] sm:text-lg" data-id="element-99" data-mp="162m8ak5kqip1">
            Quiero mi Código Solar — $17 USD
          </a>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-x-6 gap-y-2 text-[13px] text-slate-400" data-id="element-100" data-mp="1pu0riezb40mw">
          {trust.map(item => <li key={item.label} className="flex items-center gap-1.5" data-id="element-101" data-mp="3quowesbaipnt">
              <item.icon className="h-3.5 w-3.5 text-leaf-400" aria-hidden="true" data-id="element-102" data-mp="3qux8ihzl9qxy" />
              {item.label}
            </li>)}
        </ul>
      </div>
    </section>;
}